import {defineStore} from 'pinia';
import { AxiosRequestConfig } from "axios";
import handleTeacherError from "@/util/handle_teacher_error";
import apiRequest from '@/util/api-request';
import { IAvailableSubject } from '@/consts/interfaces';

interface WorkState {
  available_works_by_subject: { [cacheKey: string]: IAvailableSubject[] };
}

function buildCacheKey(academic_session_id: number, academic_year: number): string {
  return `${academic_session_id}_${academic_year}`
}

const useWorkStore = defineStore('workStore', {
  state: (): WorkState => {
    return {
      available_works_by_subject: {},
    }
  },
  getters: {
    availableWorksBySubject: (state) => (academic_session_id: number, academic_year: number) => {
      return state.available_works_by_subject[buildCacheKey(academic_session_id, academic_year)]
    },
  },
  actions: {
    async fetchAvailableWorksBySubject({
      academic_session_id,
      academic_year,
      target_years_only = false,
    }: {
      academic_session_id: number;
      academic_year: number;
      target_years_only?: boolean;
    }) {
      const cacheKey = buildCacheKey(academic_session_id, academic_year)
      if (this.available_works_by_subject[cacheKey]) {
        return
      }
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: "/teacher/api/work/available_by_subject/",
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            academic_session_id,
            academic_year,
            target_years_only,
          },
        };
        const response = await apiRequest(config);
        this.available_works_by_subject[cacheKey] = response.data.subjects
      } catch (e) {
        handleTeacherError(e)
      }
    },
  }
})

export { useWorkStore }
